<template>
  <div
    class="kds-main-wrapper"
    data-qa="prescription-support"
  >
    <div class="kds-content-block">
      <p
        :id="headingId"
        class="kds-typography-title-xlarge"
        data-qa="header"
        v-html="headerText"
      />
      <p
        class="kds-typography-paragraph-large"
        data-qa="description"
        v-html="descriptionText"
      />
    </div>
    <div class="kds-content-block">
      <BaseButton
        :text="$t('eu__prescription_support__primary_cta__one')"
        data-qa="submit"
        @click="handleEmailClick"
      />
      <BaseButton
        :text="$t('eu__prescription_support__primary_cta__two')"
        data-qa="call-support"
        @click="handlePhoneCallClick"
      />
      <div
        class="kds-typography-paragraph-medium kds-typography-center"
        v-html="supportHintText"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import env from '@shared/env.js'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'

defineProps({
  headingId: {
    type: String,
    default: undefined,
  },
})

const { t } = useI18n()
const phoneNumber = computed(() => t('eu__support__phone_number'))
const appName = computed(() => t('eu__generic__app'))
const mailTo = computed(
  () =>
    `mailto:${env.VITE_SUPPORT_EMAIL}?subject=${encodeURIComponent(appName.value)}`,
)
const rawPhoneNumber = computed(() => phoneNumber.value.replace(/\s/g, ''))
const headerText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_support__header__diga_disabled')
    : t('eu__prescription_support__header'),
)
const descriptionText = computed(() =>
  !env.features.diga
    ? t('eu__prescription_support__description__diga_disabled')
    : t('eu__prescription_support__description', { app_name: appName.value }),
)
const supportHintText = computed(() =>
  t('eu__prescription_support__hint', { phone_number: phoneNumber.value }),
)

const handlePhoneCallClick = () => {
  Tracker.trackButtonSelect(
    'call_hotline',
    'signup_get_diga_prescription_support',
  )
  const tag = document.createElement('a')
  tag.href = `tel:${rawPhoneNumber.value}`
  tag.click()
}

const handleEmailClick = () => {
  Tracker.trackButtonSelect(
    'write_email',
    'signup_get_diga_prescription_support',
  )
  const tag = document.createElement('a')
  tag.href = mailTo.value
  tag.click()
}
</script>
